import React, {useEffect} from "react";
import {createSetupIntent, hasResponseError, loadSettings} from "../../api/requests";
import {Settings} from "../../models/models";
import {PAYMENT_TYPE} from "../../constants";
import {handleError} from "../../helpers/helpers";

const PaymentMethodsDataRefreshManager = ({
                                              shouldRefresh, setSettings, setAppCenterData, setLoading,
                                              setPaymentIntentId, setClientSecretKey
                                          }) => {
    useEffect(() => {
        setLoading(true);

        let isSubscribed = true;
        isSubscribed && loadSettings((response) => {
            if (hasResponseError(response)) {
                setLoading(false);
                return;
            }

            setPaymentIntentId("");
            setSettings(new Settings(response));
            setAppCenterData(response.data.ac);
            setLoading(false);
        });
        return () => (isSubscribed = false);
    }, [shouldRefresh]);
    return <></>
}

export default PaymentMethodsDataRefreshManager;